import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SearchPaletteComponent } from './shared/components/search-palette/search-palette';
import { ToastComponent } from './shared/components/toast/toast';

@Component({
    selector: 'app-root',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, ToastComponent, SearchPaletteComponent],
    template: `
        <router-outlet />
        <app-toast />
        <app-search-palette />
    `,
})
export class App {}
